// Actions
export const REACTIVATION__GET_PRICING_AND_SELLABLE_DAYS =
  'REACTIVATION__GET_PRICING_AND_SELLABLE_DAYS';
export const REACTIVATION__GET_SELLABLE_DAYS = 'REACTIVATION__GET_SELLABLE_DAYS';
export const REACTIVATION__REACTIVATE_SERVICE = 'REACTIVATION__REACTIVATE_SERVICE';
export const REACTIVATION__DISAGREE_WITH_POLICIES = 'REACTIVATION__DISAGREE_WITH_POLICIES';
export const REACTIVATION__VALIDATE_DEAL = 'REACTIVATION__VALIDATE_DEAL';
// Getters
export const REACTIVATION__UNSELECTABLE_DAYS = 'REACTIVATION__UNSELECTABLE_DAYS';
// Mutations
export const REACTIVATION__RESET = 'REACTIVATION__RESET';
export const REACTIVATION__MUTATE_AVAILABLE_CYCLES = 'REACTIVATION__MUTATE_AVAILABLE_CYCLES';
export const REACTIVATION__MUTATE_DEAL = 'REACTIVATION__MUTATE_DEAL';
export const REACTIVATION__MUTATE_SELLABLE_DAYS = 'REACTIVATION__MUTATE_SELLABLE_DAYS';
export const REACTIVATION__MUTATE_LOADING_STATUS = 'REACTIVATION__MUTATE_LOADING_STATUS';
